import { useIntl } from "react-intl";
export var useHelpTooltip = function (labelId) {
    var messages = useIntl().messages;
    var helpId = "".concat(labelId, ".help");
    var hasHelp = helpId in messages;
    return {
        helpId: helpId,
        hasHelp: hasHelp,
    };
};
